import { render, staticRenderFns } from "./BasicCardList.vue?vue&type=template&id=9d3a55aa&scoped=true"
import script from "./BasicCardList.vue?vue&type=script&lang=ts"
export * from "./BasicCardList.vue?vue&type=script&lang=ts"
import style0 from "./BasicCardList.vue?vue&type=style&index=0&id=9d3a55aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3a55aa",
  null
  
)

export default component.exports